export const capitalizeWord = (word) => {
    return word.charAt(0).toUpperCase() + word.slice(1);
}

export const stripNonWords = (myString) => {
  //EH2021-03/03/22
    return myString.replace(/[^a-zA-ZÀ-ÿ ]+/g, '');
}

export const stripString = (string) => {
  const newRegex = new RegExp("^[a-zA-Z ]+$");
  if (newRegex.test(string)) {
    return string;
  } else {
    return '';
  }
}

export const stripStringComa = (string) => {
  const newRegex = new RegExp("[a-zA-Z, ]+$");
  if (newRegex.test(string)) {
    return string;
  } else {
    return '';
  }
}

export const decodeHTML = (html) => {
    var txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
}

//EH2021-03/03/22
export const stripNonSpecialCharacter = (myString) => {
  return myString.replace(/[^a-zA-ZÀ-ÿ0-9]+/g, '');
}
export const stripNonEmail = (myString) => {
  return myString.replace(/[()<>,;:"ç%& ÁÉÍÓÚáéíóú]/,'');
}
export const stripNonRSocial = (myString) => {
  return myString.replace(/[^a-zA-ZÀ-ÿ0-9& ]+/g, '');
}
export const stripNonComment = (myString) => {
  return myString.replace(/[^a-zA-ZÀ-ÿ0-9& ]+/g, '');
}
export const stripNonLocation = (myString) => {
  return myString.replace(/[^a-zA-ZÀ-ÿ0-9,.\- ]+/g, '');
}
